import React from 'react';
import { FormControl } from 'react-bootstrap';
import { normalizeDeviceKeyInput } from '../common/normalizeKeyInput';

class DeviceKeyInputNormalized extends React.Component {

  constructor(props) {
    super(props);
    this.state = { value: props && props.value ? props.value : '' };
    this.position = 0;
    this.inputRef = null;
  }

  handleChange = (e) => {
    const { onChange } = this.props;

    const normalizedData = normalizeDeviceKeyInput(e.nativeEvent);
    if (normalizedData === null) return;

    const { normalizedValue: normalizedDeviceKey, cursorPosition } = normalizedData;

    onChange(normalizedDeviceKey);

    this.position = cursorPosition;
    this.setState({ value: normalizedDeviceKey });
  };

  componentDidUpdate() {
    const index = this.position;
    this.inputRef.setSelectionRange(index, index);
  }

  render() {
    const { value: deviceKey } = this.state;

    return (
        <FormControl
          inputRef={(ref) => {this.inputRef = ref}}
          onChange={this.handleChange}
          value={deviceKey}
          type="text"
        />
    );
  }
}

export default DeviceKeyInputNormalized;



// WEBPACK FOOTER //
// ./src/components/deviceKeyInputNormalized.js